// Super Admin
// Organisation Admin
// Licencing Admin
// Metadata Admin - content_manager
// Metadata Contributor - content_contributor
// Pedagogy Admin
// Default access (Read Only to everything) - blank
export const teacherPermissions = ['billing_admin', 'user_admin']
